import { MenuInfo } from './menu-info';

export const ROUTES: MenuInfo[] = [
  {
    path: '',
    title: 'DASHBOARD',
    icon: 'dashboard',
    class: '',
    submenu: [],
    hasClaims: [
      'DB_STATISTICS',
      'DB_BEST_SELLING_PROS',
      'DB_RECENT_SO_SHIPMENT',
      'DB_RECENT_PO_DELIVERY',
      'DB_PROD_STOCK_ALERT',
    ],
  },
  {
    path: '',
    title: 'PRODUCT',
    icon: 'widgets',
    class: 'menu-toggle',
    hasClaims: [
      'PRO_VIEW_PRODUCTS',
      'PRO_ADD_PRODUCT',
      'PRODUCT_CATEGORY_VIEW',
      'PRODUCT_TAX_VIEW',
      'PRODUCT_UNIT_VIEW',
      'PRODUCT_BRAND_VIEW',
      'PRODUCT_VARIANT_VIEW',
      'PRODUCT_OFFER_VIEW',
      'PRO_PRINT_LABELS',
      'WAREHOUSE_VIEW',
      'PRODUCT_VIEW_REFERENCE_MOVEMENTS',
      'CLASSIFICATIONS_CLASS1_VIEW',
      'CLASSIFICATIONS_CLASS2_VIEW',
      'CLASSIFICATIONS_CLASS3_VIEW',
      'CLASSIFICATIONS_CLASS4_VIEW',
      'CLASSIFICATIONS_CLASS5_VIEW',
      'CLASSIFICATIONS_CLASS6_VIEW',
      'CLASSIFICATIONS_CLASS7_VIEW',
      'CLASSIFICATIONS_CLASS8_VIEW',
      'CLASSIFICATIONS_CLASS9_VIEW',
      'CLASSIFICATIONS_CLASS10_VIEW',
    ],
    submenu: [
      {
        path: 'products',
        title: 'LIST',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['PRO_VIEW_PRODUCTS'],
      },
      {
        path: 'products/add',
        title: 'ADD_NEW',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['PRO_ADD_PRODUCT'],
      },
      {
        path: 'product-category',
        title: 'PRODUCT_CATEGORY',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['PRODUCT_CATEGORY_VIEW'],
      },
      {
        path: 'tax',
        title: 'TAX',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['PRODUCT_TAX_VIEW'],
      },
      {
        path: 'unitConversation',
        title: 'UNIT_CONVERSATION',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['PRODUCT_UNIT_VIEW'],
      },
      {
        path: 'brand',
        title: 'BRAND',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['PRODUCT_BRAND_VIEW'],
      },
      {
        path: 'offer',
        title: 'OFFERS',
        icon: 'gift',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['PRODUCT_OFFER_VIEW'],
      },
      {
        path: 'classification/1',
        title: 'CLASSIFICATION_1',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['CLASSIFICATIONS_CLASS1_VIEW'],
      },
      {
        path: 'classification/2',
        title: 'CLASSIFICATION_2',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['CLASSIFICATIONS_CLASS2_VIEW'],
      },
      {
        path: 'classification/3',
        title: 'CLASSIFICATION_3',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['CLASSIFICATIONS_CLASS3_VIEW'],
      },
      {
        path: 'classification/4',
        title: 'CLASSIFICATION_4',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['CLASSIFICATIONS_CLASS4_VIEW'],
      },
      {
        path: 'classification/5',
        title: 'CLASSIFICATION_5',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['CLASSIFICATIONS_CLASS5_VIEW'],
      },
      {
        path: 'classification/6',
        title: 'CLASSIFICATION_6',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['CLASSIFICATIONS_CLASS6_VIEW'],
      },
      {
        path: 'classification/7',
        title: 'CLASSIFICATION_7',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['CLASSIFICATIONS_CLASS7_VIEW'],
      },
      {
        path: 'classification/8',
        title: 'CLASSIFICATION_8',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['CLASSIFICATIONS_CLASS8_VIEW'],
      },
      {
        path: 'classification/9',
        title: 'CLASSIFICATION_9',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['CLASSIFICATIONS_CLASS9_VIEW'],
      },
      {
        path: 'classification/10',
        title: 'CLASSIFICATION_10',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['CLASSIFICATIONS_CLASS10_VIEW'],
      },
      {
        path: 'variants',
        title: 'VARIANTS',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['PRODUCT_VARIANT_VIEW'],
      },
      {
        path: 'print-labels',
        title: 'PRINT_LABELS',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['PRO_PRINT_LABELS'],
      },
      {
        path: 'warehouses',
        title: 'WAREHOUSES',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['WAREHOUSE_VIEW'],
      },
      {
        path: 'reference-movements',
        title: 'REFERENCE_MOVEMENTS',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['PRODUCT_VIEW_REFERENCE_MOVEMENTS'],
      },
    ],
  },
  {
    path: '',
    title: 'DMCE',
    icon: 'gavel',
    class: 'menu-toggle',
    hasClaims: ['DMCE_COMPANIES_VIEW', 'DMCE_COUNTRIES_VIEW', 'DMCE_ORIGIN_PORTS_VIEW', 'DMCE_ENTRY_PORTS_VIEW', 'DMCE_CARRIERS_VIEW', 'DMCE_TRANSPORTS_VIEW', 'ARANCEL_VIEW'],
    submenu: [
      {
        path: 'arancel',
        title: 'ARANCELES',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['ARANCEL_VIEW'],
      },
      {
        path: 'dmce-companies-zl',
        title: 'COMPANIES_ZL',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['DMCE_COMPANIES_VIEW'],
      },
      {
        path: 'dmce-countries-zl',
        title: 'COUNTRIES_ZL',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['DMCE_COUNTRIES_VIEW'],
      },
      {
        path: 'dmce-origin-ports-zl',
        title: 'ORIGIN_PORTS_ZL',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['DMCE_ORIGIN_PORTS_VIEW'],
      },
      {
        path: 'dmce-entry-ports-zl',
        title: 'ENTRY_PORTS_ZL',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['DMCE_ENTRY_PORTS_VIEW'],
      },
      {
        path: 'dmce-carriers-zl',
        title: 'CARRIERS_ZL',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['DMCE_CARRIERS_VIEW'],
      },
      {
        path: 'dmce-transports',
        title: 'TRANSPORTS_DMCE',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['DMCE_TRANSPORTS_VIEW'],
      },
    ],
  },

  {
    path: '',
    title: 'ACCOUNTS_RECEIVABLE',
    icon: 'account_balance_wallet',
    class: 'menu-toggle',
    hasClaims: [
      'CUST_VIEW_CUSTOMERS',
      'CUST_ADD_CUSTOMER',
      'CUST_VIEW_CUSTOMER_LADGERS',
      'CXC_COBROS_VIEW',
      'CXC_TRANSACTIONS_VIEW',
    ],
    submenu: [
      {
        path: '',
        title: 'CUSTOMERS',
        icon: 'people',
        class: 'ml-sub-menu',
        hasClaims: [
          'CUST_VIEW_CUSTOMERS',
          'CUST_ADD_CUSTOMER',
          'CUST_VIEW_CUSTOMER_PENDING_PAYMENTS',
          'CUST_VIEW_CUSTOMER_LADGERS',
          'CUST_MANAGE_CUSTOMER_LADGER',
        ],
        submenu: [
          {
            path: 'customer',
            title: 'LIST',
            icon: 'target',
            class: 'ml-menu2',
            submenu: [],
            hasClaims: ['CUST_VIEW_CUSTOMERS'],
          },
          {
            path: 'customer/addItem',
            title: 'ADD_NEW',
            icon: 'target',
            class: 'ml-menu2',
            submenu: [],
            hasClaims: ['CUST_ADD_CUSTOMER'],
          },
          {
            path: 'customer-sales-order',
            title: 'PENDING_PAYMENT',
            icon: 'target',
            class: 'ml-menu2',
            submenu: [],
            hasClaims: ['CUST_VIEW_CUSTOMER_PENDING_PAYMENTS'],
          },
          {
            path: 'customer-ladger',
            title: 'CUSTOMER_LEDGER',
            icon: 'target',
            class: 'ml-menu2',
            submenu: [],
            hasClaims: ['CUST_VIEW_CUSTOMER_LADGERS', 'CUST_MANAGE_CUSTOMER_LADGER'],
          },
        ],
      },
      {
        path: 'customer-cobros',
        title: 'COLLECTIONS',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['CXC_COBROS_VIEW'],
      },
      {
        path: 'customer-transactions',
        title: 'TRANSACTION_REGISTRY',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['CXC_TRANSACTIONS_VIEW'],
      },
    ],
  },
  {
    path: '',
    title: 'ACCOUNTS_PAYABLE',
    icon: 'payments',
    class: 'menu-toggle',
    hasClaims: [
      'CXP_INVOICES_VIEW',
      'CXP_DISCOUNTS_VIEW',
      'CXP_TRANSACTIONS_VIEW',
      'CXP_BANK_DRAFTS_VIEW',
      'CXP_BANK_TRANSFERS_VIEW',
      'CXP_DIRECT_TRANSFERS_VIEW',
      'CXP_EXPENSES_VIEW',
      'CXP_PAYMENTS_VIEW',
    ],
    submenu: [
      {
        path: 'supplier-invoices',
        title: 'INVOICE_REGISTRY',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['CXP_INVOICES_VIEW'],
      },
      {
        path: 'supplier-invoice-discounts',
        title: 'INVOICE_DISCOUNT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['CXP_DISCOUNTS_VIEW'],
      },
      {
        path: 'supplier-transactions',
        title: 'SUPPLIER_TRANSACTIONS',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['CXP_TRANSACTIONS_VIEW'],
      },
      {
        path: 'supplier-bank-drafts',
        title: 'BANK_DRAFTS',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['CXP_BANK_DRAFTS_VIEW'],
      },
      {
        path: 'supplier-bank-transfers',
        title: 'BANK_TRANSFERS',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['CXP_BANK_TRANSFERS_VIEW'],
      },
      {
        path: 'supplier-direct-transfers',
        title: 'DIRECT_TRANSFERS',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['CXP_DIRECT_TRANSFERS_VIEW'],
      },
      {
        path: 'supplier-expenses',
        title: 'SUPPLIER_EXPENSES',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['CXP_EXPENSES_VIEW'],
      },
      {
        path: 'supplier-payments',
        title: 'SUPPLIER_PAYMENTS',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['CXP_PAYMENTS_VIEW'],
      },
    ],
  },
  {
    path: '',
    title: 'SUPPLIER',
    icon: 'local_shipping',
    class: 'menu-toggle',
    hasClaims: ['SUPP_VIEW_SUPPLIERS', 'SUPP_ADD_SUPPLIER'],
    submenu: [
      {
        path: 'supplier',
        title: 'LIST',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['SUPP_VIEW_SUPPLIERS'],
      },
      {
        path: 'supplier/manage/addItem',
        title: 'ADD_NEW',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['SUPP_ADD_SUPPLIER'],
      },
    ],
  },
  {
    path: '',
    title: 'SALES_ORDER_REQUEST',
    icon: 'request_quote',
    class: 'menu-toggle',
    hasClaims: ['SOR_VIEW_SO_REQUESTS', 'SOR_ADD_SO_REQUEST'],
    submenu: [
      {
        path: 'sales-order-request/list',
        title: 'LIST',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['SOR_VIEW_SO_REQUESTS'],
      },
      {
        path: 'sales-order-request/add',
        title: 'ADD_NEW',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['SOR_ADD_SO_REQUEST'],
      },
    ],
  },
  {
    path: '',
    title: 'SALES_ORDER',
    icon: 'trending_up',
    class: 'menu-toggle',
    hasClaims: ['SO_VIEW_SALES_ORDERS', 'SO_ADD_SO'],
    submenu: [
      {
        path: 'sales-order/list',
        title: 'LIST',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['SO_VIEW_SALES_ORDERS'],
      },
      {
        path: 'sales-order/add',
        title: 'ADD_NEW',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['SO_ADD_SO'],
      },
      {
        path: '',
        title: 'SALES_ORDER_RETURN',
        icon: 'keyboard_return',
        class: 'ml-sub-menu',
        hasClaims: ['SO_RETURN_SO'],
        submenu: [
          {
            path: 'sales-order-return/list',
            title: 'LIST',
            icon: 'target',
            class: 'ml-menu2',
            submenu: [],
            hasClaims: ['SO_RETURN_SO'],
          },
          {
            path: 'sales-order-return/add',
            title: 'ADD_NEW',
            icon: 'target',
            class: 'ml-menu2',
            submenu: [],
            hasClaims: ['SO_RETURN_SO'],
          },
        ],
      },
    ],
  },
  {
    path: '',
    title: 'PURCHASE_ORDER',
    icon: 'shopping_cart',
    class: 'menu-toggle',
    hasClaims: ['PO_VIEW_PURCHASE_ORDERS', 'PO_ADD_PO'],
    submenu: [
      {
        path: 'purchase/list',
        title: 'LIST',
        icon: 'target',
        class: 'ml-menu2',
        submenu: [],
        hasClaims: ['PO_VIEW_PURCHASE_ORDERS'],
      },
      {
        path: 'purchase/add',
        title: 'ADD_NEW',
        icon: 'target',
        class: 'ml-menu2',
        submenu: [],
        hasClaims: ['PO_ADD_PO'],
      },
      {
        path: '',
        title: 'PURCHASE_ORDER_REQUEST',
        icon: 'assignment',
        class: 'ml-sub-menu',
        hasClaims: ['POR_VIEW_PO_REQUESTS', 'POR_ADD_PO_REQUEST'],
        submenu: [
          {
            path: 'purchase-request/list',
            title: 'LIST',
            icon: 'target',
            class: 'ml-menu2',
            submenu: [],
            hasClaims: ['POR_VIEW_PO_REQUESTS'],
          },
          {
            path: 'purchase-request/add',
            title: 'ADD_NEW',
            icon: 'target',
            class: 'ml-menu2',
            submenu: [],
            hasClaims: ['POR_ADD_PO_REQUEST'],
          },
        ],
      },
      {
        path: '',
        title: 'PURCHASE_ORDER_RETURN',
        icon: 'keyboard_return',
        class: 'ml-sub-menu',
        hasClaims: ['PO_RETURN_PO'],
        submenu: [
          {
            path: 'purchase-return/list',
            title: 'LIST',
            icon: 'target',
            class: 'ml-menu2',
            submenu: [],
            hasClaims: ['PO_RETURN_PO'],
          },
          {
            path: 'purchase-return/add',
            title: 'ADD_NEW',
            icon: 'target',
            class: 'ml-menu2',
            submenu: [],
            hasClaims: ['PO_RETURN_PO'],
          },
        ],
      },
    ],
  },
  {
    path: '',
    title: 'PURCHASES_ORDERS',
    icon: 'shopping_bag',
    class: 'menu-toggle',
    hasClaims: ['PO_VIEW_PURCHASE_ORDERS', 'PO_ADD_PO'],
    submenu: [
      {
        path: 'purchases-orders/list',
        title: 'LIST',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['PO_VIEW_PURCHASE_ORDERS'],
      },
      {
        path: 'purchases-orders/add',
        title: 'ADD_NEW',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['PO_ADD_PO'],
      },
    ],
  },
  {
    path: '',
    title: 'SALES',
    icon: 'point_of_sale',
    class: 'menu-toggle',
    hasClaims: ['SO_VIEW_SALES_ORDERS', 'SO_ADD_SO', 'POS_OFFLINE_VIEW'],
    submenu: [
      {
        path: 'sales/list',
        title: 'LIST',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['SO_VIEW_SALES_ORDERS'],
      },
      {
        path: 'sales/add',
        title: 'ADD_NEW',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['SO_ADD_SO'],
      },
      {
        path: 'pos-offline',
        title: 'POS_OFFLINE',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['POS_OFFLINE_VIEW'],
      },
      {
        path: 'pos-offline-reception',
        title: 'POS_OFFLINE_RECEPTION',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['POS_OFFLINE_VIEW'],
      },
      {
        path: 'pos-offline/pending',
        title: 'POS_OFFLINE_PENDING',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['POS_OFFLINE_VIEW'],
      },
    ],
  },
  {
    path: '',
    title: 'INVENTORY_ADJUSTMENT',
    icon: 'inventory_2',
    class: 'menu-toggle',
    hasClaims: ['INVE_ADJ_VIEW', 'INVE_ADJ_CREATE', 'INVE_ADJ_PRINT'],
    submenu: [
      {
        path: 'inventory-adjustment/list',
        title: 'LIST',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['INVE_ADJ_VIEW'],
      },
      {
        path: 'inventory-adjustment/add',
        title: 'ADD_NEW',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['INVE_ADJ_CREATE'],
      },
    ],
  },
  {
    path: '',
    title: 'INVENTORY_TRANSFER',
    icon: 'swap_horiz',
    class: 'menu-toggle',
    hasClaims: ['INVE_TRANS_VIEW', 'INVE_TRANS_CREATE', 'INVE_TRANS_PRINT', 'STTFR_VIEW_STTFR', 'STTFR_CREATE', 'STTFR_EDIT', 'STTFR_DELETE', 'INVE_VIEW_INVENTORIES', 'INVE_MANAGE_INVENTORY'],
    submenu: [
      {
        path: 'inventory-transfer/list',
        title: 'LIST',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['INVE_TRANS_VIEW', 'STTFR_VIEW_STTFR', 'INVE_VIEW_INVENTORIES'],
      },
      {
        path: 'inventory-transfer/add',
        title: 'ADD_NEW',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['INVE_TRANS_CREATE', 'STTFR_CREATE', 'INVE_MANAGE_INVENTORY'],
      },
    ],
  },
  {
    path: '',
    title: 'ACCOUNTING',
    icon: 'account_balance',
    class: 'menu-toggle',
    hasClaims: [
      'ACCOUNTING_VIEW_LEDGER_ACCOUNTS',
      'ACCOUNTING_VIEW_FINANCIAL_YEARS',
      'ACCOUNTING_VIEW_TRANSACTIONS',
      'ACCOUNTING_VIEW_PROFIT_LOSS_REPORT',
      'ACCOUNTING_VIEW_TAX_REPORT',
      'ACCOUNTING_VIEW_CASH_BANK_REPORT',
      'ACCOUNTING_VIEW_BALANCE_SHEET_REPORT',
      'ACCOUNTING_VIEW_ACCOUNT_BALANCE_REPORT',
      'ACCOUNTING_VIEW_GENERAL_ENTRY_REPORT',
      'ACCOUNTING_VIEW_TRIAL_BALANCE_REPORT',
      'ACCOUNTING_VIEW_CASH_FLOW_REPORT',
      'ACCOUNTING_VIEW_BOOK_CLOSE'
    ],
    submenu: [
      {
        path: 'accounting/ledger-accounts',
        title: 'LEDGER_ACCOUNTS',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['ACCOUNTING_VIEW_LEDGER_ACCOUNTS'],
      },
      {
        path: 'accounting/financial-year',
        title: 'FINANCIAL_YEAR',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['ACCOUNTING_VIEW_FINANCIAL_YEARS'],
      },

      {
        path: 'accounting/transactions',
        title: 'TRANSACTION',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['ACCOUNTING_VIEW_TRANSACTIONS'],
      },
      {
        path: 'accounting/account-balance-report',
        title: 'ACCOUNT_BALANCE_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['ACCOUNTING_VIEW_ACCOUNT_BALANCE_REPORT'],
      },
      {
        path: 'accounting/balance-sheet-report',
        title: 'BALANCE_SHEET_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['ACCOUNTING_VIEW_BALANCE_SHEET_REPORT'],
      },
      {
        path: 'accounting/cash-bank-report',
        title: 'CASH_BANK_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['ACCOUNTING_VIEW_CASH_BANK_REPORT'],
      },
      {
        path: 'accounting/cash-flow-report',
        title: 'CASH_FLOW_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['ACCOUNTING_VIEW_CASH_FLOW_REPORT'],
      },
      {
        path: 'accounting/general-entry-report',
        title: 'GENERAL_ENTRY_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['ACCOUNTING_VIEW_GENERAL_ENTRY_REPORT'],
      },
      {
        path: 'accounting/profit-loss-report',
        title: 'PROFIT_VS_LOSS_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['ACCOUNTING_VIEW_PROFIT_LOSS_REPORT'],
      },
      {
        path: 'accounting/tax-report',
        title: 'TAX_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['ACCOUNTING_VIEW_TAX_REPORT'],
      },
      {
        path: 'accounting/trial-balance-report',
        title: 'TRIAL_BALANCE_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['ACCOUNTING_VIEW_TRIAL_BALANCE_REPORT'],
      },
      {
        path: 'accounting/payment-report',
        title: 'PAYMENT_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['ACCOUNTING_VIEW_PAYMENT_REPORT'],
      },
      {
        path: 'book-close',
        title: 'BOOK_CLOSE',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['ACCOUNTING_VIEW_BOOK_CLOSE'],
      },
    ],
  },
  {
    path: '',
    title: 'PAY_ROLL',
    icon: 'payments',
    class: 'menu-toggle',
    hasClaims: ['PAY_ROLL_VIEW_PAY_ROLLS', 'PAY_ROLL_CREATE'],
    submenu: [
      {
        path: 'pay-roll/list',
        title: 'LIST',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['PAY_ROLL_VIEW_PAY_ROLLS'],
      },
      {
        path: 'pay-roll/add',
        title: 'ADD_NEW',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['PAY_ROLL_CREATE'],
      },
    ],
  },
  {
    path: '',
    title: 'HUMAN_RESOURCES',
    icon: 'badge',
    class: 'menu-toggle',
        hasClaims: ['HR_VIEW_EMPLOYEES', 'PAY_ROLL_VIEW_PAY_ROLLS', 'PAY_ROLL_CREATE'],
    submenu: [
      {
        path: 'rrhh',
        title: 'EMPLOYEES',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
    hasClaims: ['HR_VIEW_EMPLOYEES', 'PAY_ROLL_VIEW_PAY_ROLLS', 'PAY_ROLL_CREATE'],
      },
    ],
  },
  {
    path: '',
    title: 'LOANS',
    icon: 'credit_score',
    class: 'menu-toggle',
    submenu: [
      {
        path: 'accounting/loans',
        title: 'LIST',
        icon: '',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['LOAN_VIEW_LOANS']
      },
      {
        path: 'accounting/loan/addItem',
        title: 'ADD_NEW',
        icon: '',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['LOAN_CREATE']
      },
    ],
    hasClaims: ['LOAN_VIEW_LOANS', 'LOAN_CREATE', 'LOAN_EDIT'],
  },
  {
    path: '',
    title: 'DAMAGE_STOCK',
    icon: 'report_problem',
    class: 'menu-toggle',
    hasClaims: ['DMG_ST_VIEW_DMG_ST', 'DMG_ST_CREATE'],
    submenu: [
      {
        path: 'damaged-stock/list',
        title: 'LIST',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['DMG_ST_VIEW_DMG_ST'],
      },
      {
        path: 'damaged-stock/add',
        title: 'ADD_NEW',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['DMG_ST_CREATE'],
      },
    ],
  },

  {
    path: '',
    title: 'STOCK_TRANSFER',
    icon: 'swap_horiz',
    class: 'menu-toggle',
    hasClaims: ['STTFR_VIEW_STTFR', 'STTFR_CREATE', 'STTFR_EDIT', 'STTFR_DELETE'],
    submenu: [
      {
        path: 'stock-transfer/list',
        title: 'LIST',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['STTFR_VIEW_STTFR'],
      },
      {
        path: 'stock-transfer/add',
        title: 'ADD_NEW',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['STTFR_CREATE'],
      },
    ],
  },
  {
    path: 'inventory',
    title: 'INVENTORY',
    icon: 'shelves',
    class: '',
    hasClaims: ['INVE_VIEW_INVENTORIES'],
    submenu: [],
  },

  {
    path: '',
    title: 'EXPENSE',
    icon: 'receipt',
    class: 'menu-toggle',
    hasClaims: ['EXP_VIEW_EXPENSES', 'EXP_ADD_EXPENSE', 'EXP_CATEGORY_VIEW'],
    submenu: [
      {
        path: 'expense',
        title: 'LIST',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['EXP_VIEW_EXPENSES'],
      },
      {
        path: 'expense/add',
        title: 'ADD_NEW',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['EXP_ADD_EXPENSE'],
      },
      {
        path: 'expense-category',
        title: 'EXPENSE_CATEGORY',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['EXP_CATEGORY_VIEW'],
      },
    ],
  },

  {
    path: '',
    title: 'REPORTS',
    icon: 'bar_chart',
    class: 'menu-toggle',
    hasClaims: [
      'REP_PO_REP',
      'REP_SO_REP',
      'REP_PO_PAYMENT_REP',
      'REP_EXPENSE_REP',
      'REP_SO_PAYMENT_REP',
      'REP_SALES_VS_PURCHASE_REP',
      'REP_PRO_PP_REP',
      'REP_PRO_SO_REPORT',
      'REP_STOCK_REPORT',
      'REP_SUP_PAYMENT_REP',
      'REP_CUST_PAYMENT_REP',
      'REP_VIEW_PRO_LOSS_REP',
      'REP_VIEW_INPUT_TAX_REP',
      'REP_VIEW_OUTPUT_TAX_REP',
      'REP_VIEW_EXPENSE_TAX_REP',
    ],
    submenu: [
      {
        path: 'purchase-report',
        title: 'PURCHASE_ORDER_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['REP_PO_REP'],
      },
      {
        path: 'sales-order-report',
        title: 'SALES_ORDER_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['REP_SO_REP'],
      },
      {
        path: 'product-purchase-report',
        title: 'PRODUCT_PURCHASE_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['REP_PRO_PP_REP'],
      },
      {
        path: 'product-sales-report',
        title: 'PRODUCT_SALES_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['REP_PRO_SO_REPORT'],
      },
      {
        path: 'stock-report',
        title: 'STOCK_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['REP_STOCK_REPORT'],
      },
      {
        path: 'purchase-payment-report',
        title: 'PURCHASE_PAYMENT_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['REP_PO_PAYMENT_REP'],
      },
      {
        path: 'sales-payment-report',
        title: 'SALES_PAYMENT_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['REP_SO_PAYMENT_REP'],
      },
      {
        path: 'expense-report',
        title: 'EXPENSE_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['REP_EXPENSE_REP'],
      },
      {
        path: 'profit-loss-report',
        title: 'PROFIT_VS_LOSS_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['REP_VIEW_PRO_LOSS_REP'],
      },
      {
        path: 'sales-purchase-report',
        title: 'SALES_VS_PURCHASE',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['REP_SALES_VS_PURCHASE_REP'],
      },
      {
        path: 'supplier-payment-report',
        title: 'SUPPLIER_PAYMENT_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['REP_SUP_PAYMENT_REP'],
      },
      {
        path: 'customer-payment-report',
        title: 'CUSTOMER_PAYMENT_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['REP_CUST_PAYMENT_REP'],
      },
      {
        path: 'reports/input-tax-report',
        title: 'INPUT_TAX_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['REP_VIEW_INPUT_TAX_REP'],
      },
      {
        path: 'reports/out-tax-report',
        title: 'OUTPUT_TAX_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['REP_VIEW_OUTPUT_TAX_REP'],
      },
      {
        path: 'reports/expense-tax-report',
        title: 'EXPENSE_TAX_REPORT',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['REP_VIEW_EXPENSE_TAX_REP'],
      },
    ],
  },

  {
    path: '',
    title: 'INQUIRY',
    icon: 'help_outline',
    class: 'menu-toggle',
    hasClaims: [
      'INQ_VIEW_INQUIRIES',
      'INQ_ADD_INQUIRY',
      'INQ_STATUS_VIEW',
      'INQ_SOURCE_VIEW',
    ],
    submenu: [
      {
        path: 'inquiry',
        title: 'LIST',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['INQ_VIEW_INQUIRIES'],
      },
      {
        path: 'inquiry/add',
        title: 'ADD_NEW',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['INQ_ADD_INQUIRY'],
      },
      {
        path: 'inquiry-status',
        title: 'INQUIRY_STATUS',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['INQ_STATUS_VIEW'],
      },
      {
        path: 'inquiry-source',
        title: 'INQUIRY_SOURCES',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['INQ_SOURCE_VIEW'],
      },
    ],
  },

  {
    path: '',
    title: 'REMINDER',
    icon: 'notifications_none',
    class: 'menu-toggle',
    hasClaims: ['REM_VIEW_REMINDERS', 'REM_ADD_REMINDER', 'REM_UPDATE_REMINDER', 'REM_DELETE_REMINDER'],
    submenu: [
      {
        path: 'reminders',
        title: 'LIST',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['REM_VIEW_REMINDERS'],
      },
      {
        path: 'reminders/add',
        title: 'ADD_NEW',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['REM_ADD_REMINDER'],
      },
    ],
  },

  {
    path: '',
    title: 'ROLES',
    icon: 'supervisor_account',
    class: 'menu-toggle',
    hasClaims: ['ROLES_VIEW_ROLES', 'ROLES_ADD_ROLE', 'ROLES_UPDATE_ROLE', 'ROLES_DELETE_ROLE'],
    submenu: [
      {
        path: 'roles',
        title: 'LIST',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['ROLES_VIEW_ROLES'],
      },
      {
        path: 'roles/manage',
        title: 'ADD_NEW',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['ROLES_ADD_ROLE'],
      },
    ],
  },
  {
    path: '',
    title: 'USERS',
    icon: 'group',
    class: 'menu-toggle',
    hasClaims: ['USR_VIEW_USERS', 'USR_ADD_USER', 'USR_UPDATE_USER', 'USR_DELETE_USER', 'USR_RESET_PWD', 'USR_ASSIGN_USR_ROLES', 'USR_ASSIGN_USR_PERMISSIONS'],
    submenu: [
      {
        path: 'users',
        title: 'LIST',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['USR_VIEW_USERS'],
      },
      {
        path: 'users/manage',
        title: 'ADD_NEW',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['USR_ADD_USER'],
      },
      {
        path: 'roles/users',
        title: 'USER_ROLES',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['USR_ASSIGN_USR_ROLES'],
      },
    ],
  },
  {
    path: '',
    title: 'EMAIL',
    icon: 'email',
    class: 'menu-toggle',
    hasClaims: [
      'EMAIL_SMTP_VIEW',
      'EMAIL_TPL_VIEW',
      'EMAIL_SEND_EMAIL',
    ],
    submenu: [
      {
        path: 'email-smtp',
        title: 'SMTP_SETTINGS',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['EMAIL_SMTP_VIEW'],
      },
      {
        path: 'emailtemplate',
        title: 'EMAIL_TEMPLATE',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['EMAIL_TPL_VIEW'],
      },
      {
        path: 'send-email',
        title: 'SEND_EMAIL',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['EMAIL_SEND_EMAIL'],
      },
    ],
  },
  {
    path: '',
    title: 'SETTINGS',
    icon: 'settings',
    class: 'menu-toggle',
    hasClaims: [
      'SETT_LOC_VIEW',
      'SETT_UPDATE_COM_PROFILE',
      'SETT_COUNTRY_VIEW',
      'SETT_CITY_VIEW',
      'SETT_LANG_VIEW',
      'SETT_PGHLP_VIEW',
    ],
    submenu: [
      {
        path: 'locations',
        title: 'BUSINESS_LOCATIONS',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['SETT_LOC_VIEW'],
      },
      {
        path: 'company-profile',
        title: 'COMPANY_PROFILE',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['SETT_UPDATE_COM_PROFILE'],
      },
      {
        path: 'languages',
        title: 'LANGUAGES',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['SETT_LANG_VIEW'],
      },
      {
        path: 'page-helper',
        title: 'PAGE_HELPER',
        icon: '',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['SETT_PGHLP_VIEW'],
      },
      {
        path: 'country',
        title: 'COUNTRY',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['SETT_COUNTRY_VIEW'],
      },
      {
        path: 'cities',
        title: 'CITY',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['SETT_CITY_VIEW'],
      },
    ],
  },
  {
    path: '',
    title: 'LOGS',
    icon: 'receipt_long',
    class: 'menu-toggle',
    hasClaims: ['LOGS_VIEW_LOGIN_AUDITS', 'LOGS_VIEW_EMAIL_LOGS', 'LOGS_VIEW_ERROR_LOGS'],
    submenu: [
      {
        path: 'login-audit',
        title: 'LOGIN_AUDIT',
        icon: 'receipt_long',
        class: 'ml-menu',
        hasClaims: ['LOGS_VIEW_LOGIN_AUDITS'],
        submenu: [],
      },
      {
        path: 'logs',
        title: 'ERROR_LOGS',
        icon: 'target',
        class: 'ml-menu',
        hasClaims: ['LOGS_VIEW_ERROR_LOGS'],
        submenu: [],
      },
      {
        path: 'email-logs',
        title: 'EMAIL_LOGS',
        icon: 'target',
        class: 'ml-menu',
        submenu: [],
        hasClaims: ['LOGS_VIEW_EMAIL_LOGS'],
      },
    ],
  },
];



